import { Check, Clipboard, Terminal } from "lucide-react";
import { useState } from "react";
import type { ZeroCommand } from "../lib/zeroCommands";

type Props = {
  command: ZeroCommand;
  compact?: boolean;
};

export const ZeroCommandCard = ({ command, compact = false }: Props) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(command.command);
    setCopied(true);
  };

  return (
    <div className="rounded-md border border-flame-400/25 bg-flame-400/[0.08] p-3 shadow-[0_0_28px_-18px_rgba(168,85,247,0.9)]">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2 text-sm font-semibold text-white/90">
            <Terminal className="h-4 w-4 text-flame-300" />
            <span>{command.title}</span>
          </div>
          <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.16em] text-white/40">
            {command.detail}
          </div>
        </div>
        <button
          type="button"
          onClick={copy}
          className="chip hover:opacity-80 flex-shrink-0"
        >
          {copied ? <Check className="h-3 w-3" /> : <Clipboard className="h-3 w-3" />}
          {copied ? "copied" : "copy"}
        </button>
      </div>
      <pre
        className={`panel-scroll mt-3 overflow-auto rounded bg-black/35 p-2 font-mono text-[10px] leading-relaxed text-white/65 ${
          compact ? "max-h-[92px]" : "max-h-[150px]"
        }`}
      >
        {command.command}
      </pre>
    </div>
  );
};
